import api from './api';

export const generateKraCycles = (data) => api.post('/kra/cycles/generate', data);

export const getKraCycles = (params = {}) => api.get('/kra/cycles', { params });

export const getKraCycle = (id) => api.get(`/kra/cycles/${id}`);

export const saveSelfResponses = (cycleId, responses) =>
  api.put(`/kra/cycles/${cycleId}/self-responses`, { responses });

export const submitSelfResponses = (cycleId) => api.post(`/kra/cycles/${cycleId}/submit-self`);

export const saveHodResponses = (cycleId, responses) =>
  api.put(`/kra/cycles/${cycleId}/hod-responses`, { responses });

export const submitHodResponses = (cycleId) => api.post(`/kra/cycles/${cycleId}/submit-hod`);

export const reopenKraCycle = (cycleId, reason) => api.post(`/kra/cycles/${cycleId}/reopen`, { reason });

export const deleteKraCycle = (cycleId, reason) => api.delete(`/kra/cycles/${cycleId}`, { params: { reason } });

export const getCycleNotes = (cycleId) => api.get(`/kra/cycles/${cycleId}/notes`);

export const addCycleNote = (cycleId, note, isPrivate = false) =>
  api.post(`/kra/cycles/${cycleId}/notes`, { note, is_private: isPrivate });
